export default __webpack_public_path__ + "static/media/Dummy 2.2b5fff79.jpg";